"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadIntersheetReferenceSource = exports.OrCadIntersheetObjectKind = void 0;
var OrCadIntersheetObjectKind;
(function (OrCadIntersheetObjectKind) {
    OrCadIntersheetObjectKind["Port"] = "port";
    OrCadIntersheetObjectKind["OffPageConnector"] = "off_page_connector";
})(OrCadIntersheetObjectKind || (exports.OrCadIntersheetObjectKind = OrCadIntersheetObjectKind = {}));
var OrCadIntersheetReferenceSource;
(function (OrCadIntersheetReferenceSource) {
    OrCadIntersheetReferenceSource["Stored"] = "stored";
    OrCadIntersheetReferenceSource["Computed"] = "computed";
})(OrCadIntersheetReferenceSource || (exports.OrCadIntersheetReferenceSource = OrCadIntersheetReferenceSource = {}));
//# sourceMappingURL=orcadIntersheetReferences.js.map